var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 611,
    height: 539,
    viewBox: "0 0 611 539",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.972 42.8716C532.977 59.5874 608.348 39.4403 633.091 85.9984C658.131 133.116 579.434 183.977 586.095 236.917C593.435 295.246 696.797 335.938 671.2 388.861C644.574 443.911 550.999 404.611 494.123 427.073C459.818 440.622 439.536 475.583 407.11 493.16C369.746 513.414 331.963 537.535 289.465 538.01C245.345 538.503 195.251 528.659 165.739 495.858C135.5 462.248 157.182 404.691 134.389 365.646C111.024 325.621 56.1078 312.375 34.651 271.295C10.1912 224.467 -8.6751 168.719 4.85421 117.649C18.3772 66.603 48.9313 47.3047 99.1381 30.9384C152.783 13.4512 214.434 30.6186 270.856 30.9384C308.253 31.1504 340.046 -1.58105 377.385 0.519544C415.727 2.6766 446.551 30.6963 482.972 42.8716Z",
    fill: "url(#paint0_linear_1_220)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_220",
    x1: 498.341,
    y1: -8.00434,
    x2: -134.659,
    y2: 570.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.8f8c7b1f9a6d7f49aa3f0eb0e56e7704.svg";
export { ForwardRef as ReactComponent };